// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { type CreateTelemetryOperations, createTelemetryOperations } from "./operations.js";
